<script lang="ts" context="module">
  import { api } from "../api/client";
  import { type Writable } from "svelte/store";
  import { termsAndConditionsCheckStatus } from "../helpers/store";

  type UnwrapWritable<T> = T extends Writable<infer U> ? U : never;

  const ENV_PATH = document.querySelector<HTMLMetaElement>('meta[name="env"]')?.content;

  const API = api.extend({
    prefixUrl: `https://hulk.${ENV_PATH}.eu-west-2.rekki.com/api/v1/`,
  });

  export function lookupTsAndCsStatus() {
    return API.post("terms_and_conditions_check", { json: {} }).json<
      NonNullable<UnwrapWritable<typeof termsAndConditionsCheckStatus>>
    >();
  }
</script>

<script lang="ts">
  import { push } from "svelte-spa-router";

  import LoginLhs from "../components/LoginLhs.svelte";
  import Stack from "../components/Stack.svelte";
  import Text from "../components/Text.svelte";
  import Button from "../components/Button.svelte";

  const links = (function transformLinks() {
    const tcs = $termsAndConditionsCheckStatus;

    if (tcs) {
      return [
        { name: "privacy policy", file: tcs.privacy_policy },
        { name: "licence agreement", file: tcs.licence_agreement },
      ];
    }

    return [];
  })();

  async function accept(_e: Event) {
    try {
      await API.post("terms_and_conditions_agree", { json: {} });
      // redirect to root, router will take over and check that everything is ok and redirect as
      // necessary.
      push("/");
    } catch (e) {
      alert(
        "A failure occurred while saving your acknowledgement. " +
          "Please try again later or contact support"
      );

      console.error("error while submitting t+c's consent", e);
    }
  }
</script>

<div class="container">
  <Stack horizontal justifyContent="stretch" alignItems="stretch">
    <div class="inner-container left">
      <LoginLhs />
    </div>
    <div class="inner-container right">
      <Stack vertical spacing="medium" alignItems="stretch">
        <div class="form-container">
          <Stack vertical alignItems="stretch">
            <Text size="large" bold>REKKI Terms &amp; Conditions</Text>

            <Text>Please read and accept the following to continue</Text>
            <ul>
              {#each links as link}
                <li>
                  <a href={link.file} target="_blank">
                    <Text>{link.name}</Text>
                  </a>
                </li>
              {/each}
              <li>
                <Text>REKKI may contact me to verify my account</Text>
              </li>
            </ul>

            <Button on:click={accept}>accept and continue</Button>
          </Stack>
        </div>
      </Stack>
    </div>
  </Stack>
</div>

<style>
  .container {
    display: flex;
    flex: 1;
    height: 100%;
  }

  .inner-container {
    display: flex;
    padding: 22px 30px 24px;
    flex-basis: 50%;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
  }
  .left {
    background-color: var(--rekki-neutral-02);
  }

  .right {
    background-color: var(--rekki-light);
  }

  .form-container {
    display: flex;
  }

  ul {
    margin: 29px 0px;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
</style>
